<template>
  <div id="story-step-container">
    <div class="svg-container">
      <svg id="svg-line" :style="{'width': svgWidth}">
        <g v-for="(step, index) in data">
          <rect v-if="index < data.length - 1" :width="barWidth" height="10" fill="#F8F3D1" y="5" :x="(index * barWidth) + 20"></rect>
          <circle r="10" fill="#EFE28A" cy="10" :cx="(index * barWidth) + 30" @click="goToStep(index)"></circle>
        </g>
      </svg>
    </div>
    <div class="age-container" v-bind:class="{last: isLastStep}">
      <div class="label" v-if="!isLastStep">{{$t('story.age')}}</div>
      <div class="age" v-if="!isLastStep">{{localeAge}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "story-step-age",
    props: ['data'],
    computed: {
      currentStory() {
        if (this.data.length > 0)
          return this.data[this.$store.state.storyStep]
        else
          return {}
      },
      svgWidth() {
        return (this.data.length * (this.barWidth + 22)) + 'px'
      },
      barWidth () {
        return Math.max(80, window.innerWidth / this.data.length )
      },
      localeAge () {
        if (this.currentStory.age) {
          let loc = this.$i18n.locale == 'ar' ? 'ar-EG' : 'en'
          let age = parseInt(this.currentStory.age)
          return age.toLocaleString(loc)
        }
      },
      isLastStep () {
        return this.$store.state.storyStep == this.data.length - 1
      },
    },
    methods:{
      updateLinePosition(){
        this.$el.querySelector('#svg-line').style.left = (- this.$store.state.storyStep * this.barWidth) + 'px'
      },
      goToStep (step) {
        this.$store.state.storyStep = step
      }
    },
    watch: {
      currentStory: function(){
        this.updateLinePosition()
      }
    }
  }
</script>

<style scoped>
  #story-step-container{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 88px;
    box-shadow: 0pt 3pt 18pt rgba(0,0,0, 0.16);
    background: #ffffff;
    overflow: hidden
  }

  .age-container{
    position: absolute;
    margin: 16px 50px;
    height: 50px;
    width: 50px;
    border: 1px solid #FFDD00;
    background: #fff;
    text-align: center;
  }
  .age-container.last{
    background: none;
  }
  .age-container .label{
    line-height: 26px
  }
  .age-container .age{
    font-weight: bold;
    font-size: 15px;
  }
  .svg-container{
    position: absolute;
    top: calc(50% - 10px);
    left: 50px;
    width: calc(90% - 50px);
    height: 20px;
  }
  #svg-line{
    position: absolute;
    left: 0px;
    transition: 0.5s;
  }
  #svg-line circle:hover{
    cursor: pointer;
    fill: rgb(204, 190, 96);
  }

.ar .age-container .label{
    line-height: 22px
  }
</style>



// WEBPACK FOOTER //
// src/components/StoryStepAge.vue